import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from './../../../state/reducer';
import * as fromRecaptcha from './recaptcha.reducer';
import * as fromFormState from './form-state.reducer';
import * as fromLookup from './lookup.reducer';
import * as fromLogger from './logger.reducer';
import * as fromToast from './toast.reducer';
import * as fromSpinner from './spinner.reducer';
import * as fromTitle from './title.reducer';
import * as fromAuthentication from './authentication.reducer';

export interface State extends fromRoot.State {
  shared: SharedState;
}

export interface SharedState {
  authentication: fromAuthentication.State;
  recaptcha: fromRecaptcha.State;
  formState: fromFormState.State;
  lookup: fromLookup.State;
  logger: fromLogger.State;
  toast: fromToast.State;
  spinner: fromSpinner.State;
  title: fromTitle.State;
}

export const reducers: ActionReducerMap<SharedState> =
{
  authentication: fromAuthentication.reducer,
  recaptcha: fromRecaptcha.reducer,
  formState: fromFormState.reducer,
  lookup: fromLookup.reducer,
  logger: fromLogger.reducer,
  toast: fromToast.reducer,
  spinner: fromSpinner.reducer,
  title: fromTitle.reducer,
}

export const getSharedFeatureState = createFeatureSelector<SharedState>('shared');
export const getAuthenticationState = createSelector(getSharedFeatureState, state => state.authentication);
export const getLookupState = createSelector(getSharedFeatureState, state => state.lookup);

